import { createAsyncThunk } from "@reduxjs/toolkit";

import TOAST from "../../utils/constants/toast";
import {
  AgencyAPI,
  ICreateAgencyRequest,
  ICreateAgentRequest,
} from "../services/AgencyService";
import { showToast } from "../slices/toastSlice";

export const getAgencyDetails = createAsyncThunk(
  "agency/getAgencyDetails",
  async (agency: string, { dispatch }) => {
    const { data } = await dispatch(
      AgencyAPI.endpoints.getAgencyDetails.initiate(agency),
    );

    return data;
  },
);

export const createAgency = createAsyncThunk(
  "agency/createAgency",
  async (agency: ICreateAgencyRequest, { dispatch, rejectWithValue }) => {
    const { status, data, error } = await dispatch(
      AgencyAPI.endpoints.createAgency.initiate(agency),
    );

    if (status === "rejected") {
      dispatch(
        showToast({
          type: TOAST.ERROR_TYPE,
          message: "Something went wrong",
          duration: TOAST.DEFAULT_DURATION,
        }),
      );

      return rejectWithValue(error);
    }

    dispatch(
      showToast({
        type: TOAST.SUCCESS_TYPE,
        message: "Agency successfully created",
        duration: TOAST.DEFAULT_DURATION,
      }),
    );

    return data?.id;
  },
);

export const createAgent = createAsyncThunk(
  "agency/createAgent",
  async (
    agent: ICreateAgentRequest & { successMessage?: string },
    { dispatch, rejectWithValue },
  ) => {
    const { successMessage, ...rest } = agent;
    const { status, data, error } = await dispatch(
      AgencyAPI.endpoints.createAgent.initiate(rest),
    );

    if (status === "rejected") {
      if ("data" in error) {
        const errors = Object.values(error.data as Record<string, string[]>);

        errors.forEach((errorsArr) => {
          errorsArr.forEach((err) => {
            const message = err.charAt(0).toUpperCase() + err.slice(1);

            dispatch(
              showToast({
                type: TOAST.ERROR_TYPE,
                message,
                duration: TOAST.DEFAULT_DURATION,
              }),
            );
          });
        });
      } else {
        dispatch(
          showToast({
            type: TOAST.ERROR_TYPE,
            message: "Something went wrong",
            duration: TOAST.DEFAULT_DURATION,
          }),
        );
      }

      return rejectWithValue(error);
    }

    dispatch(
      showToast({
        type: TOAST.SUCCESS_TYPE,
        message: successMessage ?? "Agent successfully created",
        duration: TOAST.DEFAULT_DURATION,
      }),
    );

    return data;
  },
);
